import Vue from 'vue' ;
import {namespace} from 'vuex-class' ;
import {PROFILE_MODULE_NAMESPACE, PROFILE_SET_MEMBER_BY_FIELD} from '../../../../store/profile/profile-types.store';
import {ITeamMember} from '../../../../models/profile/member.model';
import {IAddress} from '../../../../models/address/address.model';
import {USER_MODULE_NAMESPACE, USER_SET_USER_BY_FIELD} from '../../../../store/user/user-types.store';
import {IUser} from '../../../../models/user/user.model';
import {CrudStatus} from '../../../../common/enums';


const ProfileStore = namespace(PROFILE_MODULE_NAMESPACE)
const UserStore = namespace(USER_MODULE_NAMESPACE)


export class MemberViewModel extends Vue {


  @ProfileStore.Mutation(PROFILE_SET_MEMBER_BY_FIELD)
  storeSetMemberByValue: (payload?: any) => void

  @UserStore.Mutation(USER_SET_USER_BY_FIELD)
  storeSetUserByValue: (payload?: any) => void

  @ProfileStore.Getter member: ITeamMember
  @ProfileStore.Getter profileCrudActionStatus: CrudStatus
  @UserStore.Getter userCrudActionStatus: CrudStatus
  @UserStore.Getter user: IUser


  constructor() {
    super()
  }

  get model(): any {
    return this.userCrudActionStatus === CrudStatus.Update ? this.user : this.member
  }

  get modelSetter() {
    return this.userCrudActionStatus !== CrudStatus.Update ? this.storeSetMemberByValue : this.storeSetUserByValue
  }

  get role() {
    return this.model.role
  }

  set role(value: number) {
    this.modelSetter({role: value})
  }

  get civility(): number {
    return this.model.civility
  }

  set civility(value: number) {
    this.modelSetter({civility: value})
  }

  get lastname() {
    return this.model.lastname
  }

  set lastname(value: string) {
    this.modelSetter({lastname: value})
  }

  get firstname() {
    return this.model.firstname
  }

  set firstname(value: string) {
    this.modelSetter({firstname: value})
  }

  get address(): IAddress {
    return this.model.address
  }

  set address(value: IAddress) {
    this.modelSetter({address: value})
  }

  get email() {
    return this.model.email
  }

  set email(value: string) {
    this.modelSetter({email: value})
  }

  get fake_email () {
    return this.model.fake_email
  }

  set fake_email(value: string) {
    this.modelSetter({fake_email:value})
  }

  get password () {
    return this.model.password
  }

  set password(value: string) {
    this.modelSetter({password:value})
  }

  get cellphone() {
    return this.model.cellphone
  }

  set cellphone(value: string) {
    this.modelSetter({cellphone: value!.trim().replace(/\s/g, '')})
  }

  get landline() {
    return this.model.landline
  }

  set landline(value: string) {
    this.modelSetter({landline: value!.trim().replace(/\s/g, '')})
  }

  get num_SIRET() {
    return this.model.num_siret
  }

  set num_SIRET(value: number) {
    this.modelSetter({num_siret: value})
  }

  get code_ape() {
    return this.model.code_ape
  }

  set code_ape(value: string) {
    this.modelSetter({code_ape: value})
  }

  get num_TVA() {
    return this.model.num_tva
  }

  set num_TVA(value: string) {
    this.modelSetter({num_tva: value})
  }

  get specialization() {
    return this.model.specialization
  }

  set specialization(value: number[]) {
    this.modelSetter({specialization: value})
  }

  get blocks() {
    return this.model.blocks
  }

  set blocks(value: any[]) {
    this.modelSetter({blocks: value})
  }

  get charPb1 () {
    return this.model.charPb1
  }

  set charPb1 (value: number[]) {
    this.modelSetter({charPb1: value})
  }

  get charPb2 () {
    return this.model.charPb2
  }

  set charPb2 (value: number[]) {
    this.modelSetter({charPb2: value})
  }

  get apartments() {
    return this.model.apartments
  }

  set apartments(value: any[]) {
    this.modelSetter({apartments: value})
  }

  get oldPassword(): string {
    return this.model.old_password
  }

  set oldPassword(password: string) {
    this.modelSetter({old_password: password})
  }

  get newPassword(): string {
    return this.model.new_password
  }

  set newPassword(password: string) {
    this.modelSetter({new_password: password})
  }

  get trigram(): string {
    return this.model.trigram
  }

  set trigram(trigram: string) {
    this.modelSetter({trigram: trigram})
  }

  get parentEntity() {
    return this.model.parent_entity
  }

  set parentEntity(value: number) {
    this.modelSetter({parent_entity: value})
  }
}



// WEBPACK FOOTER //
// ./src/containers/profile/components/profile-modal-vertical/member.viewmodel.ts